<p-toast position="bottom-right"></p-toast>
<div class="background-image justify-content-around w-full flex flex-column">
  <app-label-description-custom
    [icon]="'pi pi-tag'"
    [title]="'features.customer-page.customer' | translate | uppercase"
  ></app-label-description-custom>
  <div
    class="flex flex-column w-full align-items-center height-table px-6 flex-grow"
  >
    <div
      class="flex flex-row w-full justify-content-between align-items-center"
    >
      <p-button
        [icon]="'pi pi-plus-circle'"
        [label]="'features.customer-page.new-customer' | translate"
        [raised]="true"
        [styleClass]="'primary-custom'"
        (click)="goToInsert()"
      />
      <app-filter-search-custom
        [(value)]="searchQuery"
        (valueChange)="table.applyFilterGlobal($event)"
      ></app-filter-search-custom>
    </div>
    <div class="flex flex-column w-full flex-grow">
      <app-table-custom
        #table
        [columns]="cols"
        [data]="dataTable"
        [countLabel]="'features.customer-page.customers' | translate"
      ></app-table-custom>
    </div>
  </div>
  <div
    class="flex flex-row w-full pl-6 justify-content-between align-items-center"
  >
    <p-button
      [icon]="'pi pi-chevron-left'"
      [label]="'shared.back' | translate"
      [outlined]="true"
      severity="secondary"
      [styleClass]="'secondary-custom'"
      (click)="goHome()"
    />
  </div>
</div>
<app-dialog-attachment-custom
  [type]="ExtensionsEnum.IMAGE"
  *ngIf="customer"
  [title]="customer.businessName"
  [visible]="dialogLogoVisible"
  (onClose)="dialogLogoVisible = false"
>
  <div class="flex flex-row overflow-x-hidden col-12">
    <div class="flex flex-column col-5 p-2 align-items-start gap-3">
      <div
        *ngFor="let logoItem of logo"
        class="flex flex-row gap-4 align-items-center justify-content-between w-full"
      >
        <div class="flex flex-column col-9 p-2 align-items-start gap-3">
          <div class="flex flex-row">
            <i class="pi pi-image text-sm mr-2"></i>
            <span class="font-bold">{{ logoItem.originalName }}</span>
          </div>
          <div class="flex align-items-start gap-2">
            <span>{{ logoItem.size | stringifyFileSize }}</span>
          </div>
          <div class="flex align-items-start gap-2">
            <button
              pButton
              icon="pi pi-download"
              [rounded]="true"
              [text]="true"
              (click)="downloadLogo()"
              class="ml-auto bg-transparent view-download"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-column col-1">
    </div>
    <p-divider layout="vertical" />
    <div class="flex flex-column col-6 p-2">
      <img [src]="logoUrl" alt="Logo" />
    </div>
  </div>
</app-dialog-attachment-custom>
